import type { Accordion } from "services/cms/models/accordion";
import type { AccordionGroup } from "services/cms/models/accordionGroup";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

import richTextResolver from "./richTextResolver";

export type ResolvedAccordionGroup = {
    [key: string]: any;
};

const resolveAccordion = (accordion: Accordion) => {
    return {
        id: accordion.system.id,
        title: accordion.elements.title.value,
        subTitle: accordion.elements.subtitle.value,
        summary: richTextResolver({
            html: accordion.elements.summary.value,
            linkedItems: accordion.elements.summary.linkedItems,
        }),
        children: richTextResolver({
            html: accordion.elements.content.value,
            linkedItems: accordion.elements.content.linkedItems,
        }),
    };
};

const accordionGroupResolver = (accordionGroup: AccordionGroup): ResolvedAccordionGroup => {
    const items = accordionGroup.elements.items.linkedItems;

    return {
        codename: accordionGroup.system.codename,
        accordions: items.length ? items.map(resolveAccordion) : [],
        type: ContentTypeCodenames.AccordionGroup,
    };
};

export default accordionGroupResolver;
